import { useEffect, useState } from "react";

// 값이 멈춘 뒤 delayMs 가 지나야 바뀌는 사본 — 키 입력마다 요청이 나가지 않게 할 때 쓴다.
const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
